import CloseIcon from "@mui/icons-material/Close";
import { Alert, AlertTitle, IconButton } from "@mui/material";
import { MainContext } from "common/interfaces/MainContext";
import { MainContextContainer } from "components/Main";
import { Login } from "components/Pages/Login";
import { Confirm } from "components/Parts/Molecules/Confirm";
import { ProgressBackdrop } from "components/Parts/Molecules/ProgressBackdrop";
import { memo } from "react";
import { AgreementDialog } from "../AgreementDialog";
import styles from "./Auth.module.scss";
import { useAuthHooks } from "./hooks";
import { AuthProps } from "./interfaces";
import { TrialExpiredMessage } from "./TrialExpiredMessage";

export const Auth = memo((props: AuthProps) => {
  const {
    user,
    userInfo,
    groups,
    company,
    defaultConditionOfUser,
    setDefaultConditionOfUser,
    showConfirmSignOut,
    showRecommendSignOut,
    busy,
    authUser,

    fatalMessage,
    forceLogoutMessage,
    setFatal,

    logoVisible,
    setLogoVisible,

    signOut,
    authStatus,

    location,

    isAuthenticated,
    isAgreed,
    isReadyToUse,

    showFatal,
    showForceLogout,

    trialExpired,

    onChangeSignInState,
    onInvokeSignOut,

    onSignOutClick,
    onConfirmSignOutClose,
    onConfirmSignOutCloseClick,
    onRecommendSignOutClose,
    onRecommendSignOutCloseClick,
    onSessionMissing,
    onCloseFatal
  } = useAuthHooks();

  const mainContext: MainContext = {
    authStatus,
    authUser,

    user,
    company,

    userInfo,
    groups,

    defaultConditionOfUser,

    isAuthenticated,
    isAgreed,
    isReadyToUse,

    logoVisible,

    setDefaultConditionOfUser,

    setFatal,
    setLogoVisible,

    signOut,

    onSignOutClick,
    onChangeSignInState,
    onInvokeSignOut,
    onSessionMissing
  };

  return (
    <>
      <MainContextContainer.Provider value={mainContext}>
        {!isAuthenticated &&
        !location.pathname.startsWith("/pub") &&
        !location.pathname.startsWith("/about") &&
        !location.pathname.startsWith("/license") ? (
          // 未認証の場合は、ログインページを表示
          <Login />
        ) : trialExpired ? (
          <TrialExpiredMessage user={user} signOut={signOut} />
        ) : (
          props.children
        )}
      </MainContextContainer.Provider>
      {(showFatal || showForceLogout) && (
        <Alert
          className={styles.alert}
          severity={showForceLogout ? "warning" : "error"}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              onClick={onCloseFatal}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <AlertTitle>{showForceLogout ? "警告" : "エラー"}</AlertTitle>
          {showForceLogout ? forceLogoutMessage : fatalMessage}
        </Alert>
      )}
      <Confirm
        open={showConfirmSignOut}
        content="ログアウトします。"
        onClose={onConfirmSignOutClose}
        onOkClick={onInvokeSignOut}
        onCloseClick={onConfirmSignOutCloseClick}
      ></Confirm>
      <Confirm
        open={showRecommendSignOut}
        content="ログイン期限が切れました。ログアウトします。"
        onClose={onRecommendSignOutClose}
        onOkClick={onInvokeSignOut}
        onCloseClick={onRecommendSignOutCloseClick}
      ></Confirm>
      {isAgreed === undefined ? null : (
        <AgreementDialog
          open={isAuthenticated && !isAgreed}
          mainContext={mainContext}
          errorMessage=""
          onOkButtonClick={(value) => {
            if (value.User?.agreement) {
              window.location.href = `${window.location.href}`;
            }
          }}
        />
      )}
      <ProgressBackdrop open={busy} />
    </>
  );
});
